import {utilHelper} from "../../_helpers";
import {SUCCESSFUL_TRANSLATION_LABEL} from "../../../components/i18n/i18n";

const relativeUrl = 'api/aybMenu'

export const aybMenuService = {
    getItem,
    saveItem,
    updateItem,
    deleteItem,
    search,
    translate,
    reorderItems,
    cleanPrices,
    getOptions
};


//search
function search(offset, max, data){
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/search?max=${max}&offset=${offset}`, 'POST', { data: data, showAlert:false })
}

//getOptions
function getOptions(data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/getOptions`, 'POST', { data:data, showAlert:false })
}

//show
function getItem(id) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/${id}`, 'GET', {})
}

//save
function saveItem(data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}`, 'POST', { data: data });
}

//update
function updateItem(id, data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/${id}`, 'PUT', { data: data });
}

//delete
function deleteItem(id, fbDB) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/${id}/${fbDB}`, 'DELETE',{})
}

function translate(id, data){
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/translate/${id}`, 'POST', { data: data, message:SUCCESSFUL_TRANSLATION_LABEL });
}

//reorder
function reorderItems(data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/reorder`, 'POST', { data: data });
}

function cleanPrices(id, fbDataBaseId) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/cleanPrices/${id}/${fbDataBaseId}`, 'DELETE',{})
}